import { create } from "zustand";

type Sample = { name: string; duration: number; at: number };

interface PerformanceState {
  samples: Sample[];
  record: (name: string, duration: number) => void;
}

export const usePerformanceStore = create<PerformanceState>((set) => ({
  samples: [],
  record: (name, duration) =>
    set((state) => ({
      samples: [...state.samples.slice(-199), { name, duration, at: Date.now() }],
    })),
}));

export function recordDuration(name: string, startedAt: number): void {
  const duration = performance.now() - startedAt;
  performance.measure(name, { start: startedAt, end: performance.now() });
  usePerformanceStore.getState().record(name, duration);
}

export function summarize(values: number[]): {
  p50: number;
  p95: number;
  max: number;
} {
  if (!values.length) return { p50: 0, p95: 0, max: 0 };
  const sorted = [...values].sort((a, b) => a - b);
  return {
    p50: sorted[Math.floor((sorted.length - 1) * 0.5)],
    p95: sorted[Math.floor((sorted.length - 1) * 0.95)],
    max: sorted[sorted.length - 1],
  };
}
